<template>
<div class="webheader pf " style="direction: ltr !important;">
    <div class="headerMenu">
        <div class="headerMenuLogo m_mb20">
            <div class="g_nm w100 m_w50 vm " style="text-align: left;">
                <router-link to="/" class="pointer z10">
                <img src="@/assets/imgs/logo11.png" alt="logo" class="headerMenuLogoImg" />
            </router-link>
            </div>
            <div class="g_nm h m_sib w100 m_w50 vm m_r">
                <img src="@/assets/imgs/logoHeader.png" alt="logo" class="w100" style="max-width: 250px;" />
            </div>

        </div>

        <div class="headerMenuBoxmobile" @click="showMMenu()">Menu</div>
        <div class="headerMenuBox">
            <div class="headerMenuItem">
            <router-link to="/" :class="{ active: $route.path=='/' && $route.query.to != 'faqs' }" class="headerMenuItemLink">Home</router-link>
            </div>
            <div class="headerMenuItem">
            <router-link to="/about" :class="{ active: $route.path=='/about' }" class="headerMenuItemLink">About</router-link>
            </div>
            <div class="headerMenuItem">
            <router-link to="/why-alula" :class="{ active: $route.path=='/why-alula' }" class="headerMenuItemLink">Why AlUla</router-link>
            </div>
            <div class="headerMenuItem">
            <router-link to="/agenda" :class="{ active: $route.path=='/agenda' }" class="headerMenuItemLink">Agenda</router-link>
            </div>
            <div class="headerMenuItem">
            <router-link to="/speakers" :class="{ active: $route.path=='/speakers' }" class="headerMenuItemLink">Speakers</router-link>
            </div>
            <!-- <div class="headerMenuItem">
                <router-link to="/media-center" class="headerMenuItemLink">Media Center</router-link>
            </div> -->
            <div class="headerMenuItem">
                <router-link to="/?to=faqs" class="headerMenuItemLink" :class="{ active: $route.path === '/' && $route.query.to === 'faqs' }" >FAQs</router-link>
            </div>
            <div class="headerMenuItem">
                <router-link to="/contact" :class="{ active: $route.path=='/contact' }"  class="headerMenuItemLink">Contact Us</router-link>
            </div>
            <!-- <div class="headerMenuItem">
                <router-link to="/media-center" :class="{ active: $route.path=='/media-center' }"  class="headerMenuItemLink">Media Center</router-link>
            </div> -->
        </div>
        <div class="headerMenuLogo m_h">
            <img src="@/assets/imgs/logoHeader.png" alt="logo" class="w100" style="max-width: 250px;" />
        </div>
    </div>
</div>

<div v-if="$store.state.loader==1" class="z2000 pf ov bgw60"></div>
<router-view></router-view>
<footer class="cov pt20 pb40" style="background-position:left bottom" :style="{ backgroundImage: 'url(' + require('@/assets/imgs/footealular.896063a9.webp') + ')' }">
    <div class="fs0">
        <div class="g_nm p5"><a href="https://x.com/AlUlaCEME" target="_blank"><img class="footerIcon pointer" src="@/assets/imgs/footerX.svg" style="width:40px;" alt=""></a></div>
        <div class="g_nm p5"><a href="https://www.youtube.com/@AlUlaCEME" target="_blank"><img class="footerIcon pointer" src="@/assets/imgs/youtubeFooter.png" style="width:40px;" alt=""></a></div>
        <!-- <div class="g_nm p5"><a href="https://www.instagram.com/alulaceme?igsh=ZzNodnFxbXJzd2xo" target="_blank"><img class="footerIcon pointer" src="@/assets/imgs/footerI.svg" style="width:40px;" alt=""></a></div> -->
        <div class="g_nm p5"><a href="https://www.linkedin.com/company/alula-conference-for-emerging-market-economies/" target="_blank"><img class="footerIcon pointer" src="@/assets/imgs/footerL.svg" style="width:40px;" alt=""></a></div>
        <div class="g_nm p5"><a href="https://www.facebook.com/share/1EGmEFp4FP/?mibextid=wwXIfr" target="_blank"><img class="footerIcon pointer" src="@/assets/imgs/footerF.svg" style="width:40px;" alt=""></a></div>
    </div>
    <div class="mt30 nw ph10">
        <div class="g_nm vm ph50 m_ph40">
            <div class="ov ml30 ba  pt2 bgBeige"></div>
            <img src="@/assets/imgs/sqW.svg" class="ov ra ba " alt="" style="width: 30px; top:-9.5px">
        </div>
        <div class="g_nm vm fs18 m_fs16 m_m_fs13 b cBeige ph20 m_m_ph15 upper">{{ $t('organized by') }}</div>
        <div class="g_nm vm ph50 m_ph40">
            <div class="ov mr30 ba  pt2 bgBeige"></div>
            <img src="@/assets/imgs/sqW.svg" class="ov la ba " alt="" style="width: 30px; top:-9.5px">
        </div>
    </div>
    <img src="@/assets/imgs/logoFooter.png" alt="" style="max-width:300px;" class="mt10 w100">
    <div class="mt10">
        <div class="g_nm vm ph50 m_ph40 m_m_ph30 md_h">
            <div class="ov ml30 ba  pt2 bgBeige"></div>
            <img src="@/assets/imgs/sqW.svg" class="ov ra ba " alt="" style="width: 30px; top:-9.5px">
        </div>
        <div class="g_nm vm fs18 m_fs16 m_m_fs13 b cBeige ph20 m_m_ph10 upper textwrapm" style="direction:ltr !important" >© 2025 AlUla Conference for Emerging Market Economies. All Rights Reserved.</div>
        <div class="g_nm vm ph50 m_ph40 m_m_ph30 md_h">
            <div class="ov mr30 ba  pt2 bgBeige"></div>
            <img src="@/assets/imgs/sqW.svg" class="ov la ba " alt="" style="width: 30px; top:-9.5px">
        </div>
    </div>
</footer>
</template>

<script>
export default {
    name: 'RegLayout',
    created() {
        // if(this.$cookies.isKey("_AUlaLang")){
        // if(this.$cookies.get("_AUlaLang")=='en'){
        //   this.$i18n.locale='ar';
        // }
        // else{
        //   this.$i18n.locale='en';
        // }
        // this.changeLang()
        // }
    },

    methods: {
        showMMenu() {
            const menuBox = document.querySelector('.headerMenuBox');
            if (menuBox.style.display === 'none' || menuBox.style.display === '') {
                $(menuBox).slideDown();
            } else {
                $(menuBox).slideUp();
            }
        },
        changeLang() {
            if (this.$i18n.locale == "en") {
                $('html').attr('lang', 'ar');
                this.$i18n.locale = 'ar';
                $('body').addClass('rtl');
                const expirationTime = 100 * 60 * 60;
                this.$cookies.set("_AUlaLang", 'ar', expirationTime);
            } else {
                $('html').attr('lang', 'en');
                this.$i18n.locale = 'en';
                $('body').removeClass('rtl');
                const expirationTime = 100 * 60 * 60;
                this.$cookies.set("_AUlaLang", 'en', expirationTime);
            }
        },
    }
}
</script>
